@let t = text();

<div class="transits-vertical" [class.transits-vertical--wide]="wide()">
  @if (legendVisible()) {
    <div class="transits-vertical__toolbar">
      <hd-transit-legend-filter class="transits-vertical__legend" [showChiron]="showChiron()" scope="vertical" />

      @if (!phone() && !gateInfoInWeekStrip()) {
        <ng-container *ngTemplateOutlet="gateInfoToggle" />
      }
    </div>
  }

  <hd-transit-week-strip
    class="transits-vertical__week"
    [focusDayKey]="focusDayKey()"
    [todayKey]="todayKey()"
    [compact]="!wide()"
    [calendarToggle]="!wide()"
    [calendarOpen]="calendarOpen()"
    [sunLines]="weekSunLines()"
    (daySelected)="jumpTo($event)"
    (nowSelected)="jumpToNow()"
    (calendarToggled)="toggleCalendar()"
  >
    <!-- Smal (o.a. rechterpaneel): naast de kalenderknop, waar plaats is; onder
         de legende zou de schakelaar een eigen regel innemen. -->
    <span weekStripEnd class="transits-vertical__week-end">
      @if (phone()) {
        <!-- Phone: planetenfilter achter een knop, zodat de dag-flow hoger begint. -->
        <button
          type="button"
          class="transits-vertical__legend-toggle"
          [class.is-active]="legendOpen()"
          [attr.aria-pressed]="legendOpen()"
          [attr.aria-label]="legendOpen() ? t.legendFilterHide : t.legendFilterShow"
          [title]="legendOpen() ? t.legendFilterHide : t.legendFilterShow"
          data-test-id="transits-legend-toggle"
          (click)="toggleLegend()"
        >
          <i class="fas fa-filter" aria-hidden="true"></i>
        </button>
      } @else if (gateInfoInWeekStrip()) {
        <ng-container *ngTemplateOutlet="gateInfoToggle" />
      }
    </span>
  </hd-transit-week-strip>

  @if (!wide() && calendarOpen()) {
    <div class="transits-vertical__calendar transits-vertical__calendar--inline">
      <ng-container *ngTemplateOutlet="monthCalendar" />
    </div>
  }

  @if (error(); as errorText) {
    <p class="transits-vertical__notice" [title]="errorText">{{ t.error }}</p>
  }

  <div class="transits-vertical__body">
    @if (flowLoading()) {
      <!-- Zwevend boven de dag-flow: geen layout-verschuiving tijdens het laden. -->
      <div class="transits-vertical__loading" role="status" data-test-id="transits-vertical-loading">
        <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
        {{ t.loading }}
      </div>
    }
    <hd-transit-day-flow
      #dayFlow
      class="transits-vertical__flow"
      [planets]="flowPlanets()"
      [todayKey]="todayKey()"
      [initialFocusKey]="initialFocusKey"
      [initialOffsetPx]="initialOffsetPx"
      [nowMs]="nowMinuteMs()"
      [compact]="!wide()"
      [gateInfoMode]="gateInfoMode()"
      [gateShiftBadge]="gateShiftBadge()"
      [justNowAvailable]="justNowAvailable()"
      (focusDayChanged)="onFocusDayChanged($event)"
      (windowChanged)="onWindowChanged($event)"
      (momentAddRequested)="momentAddRequested.emit($event)"
      (justNowRequested)="justNowRequested.emit()"
      (raveNewYearRequested)="raveNewYearRequested.emit($event)"
    />

    @if (wide()) {
      <aside class="transits-vertical__calendar transits-vertical__calendar--aside">
        <ng-container *ngTemplateOutlet="monthCalendar" />
      </aside>
    }
  </div>
</div>

<!-- Poortinfo bij de wissels: poortlink, badge met de keynotes, of een extra poortrij. -->
<ng-template #gateInfoToggle>
  <e-segmented-toggle
    class="transits-vertical__gate-info"
    size="xs"
    testId="transits-gate-info"
    [groupLabel]="text().gateInfoLabel"
    [options]="gateInfoOptions()"
    [value]="gateInfoMode()"
    (valueChange)="setGateInfoMode($event)"
  ></e-segmented-toggle>
</ng-template>

<ng-template #monthCalendar>
  <hd-moments-calendar
    variant="transits"
    [compact]="!wide()"
    [dayBadges]="calendarBadges()"
    [focusDayKey]="focusDayKey()"
    [todayKey]="todayKey()"
    [initialMonthKey]="calendarMonthKey()"
    [dayCorner]="sunLineCorner"
    (daySelected)="onCalendarDaySelected($event)"
    (visibleMonthChanged)="onCalendarMonthChanged($event)"
  >
    <!-- Poort- of lijnwissels als glyph (setting), rechts in de kalendertoolbar. -->
    <e-segmented-toggle
      hdCalendarToolbarEnd
      size="xs"
      testId="transits-calendar-granularity"
      [groupLabel]="text().granularityLabel"
      [options]="granularityOptions()"
      [value]="badgeGranularity()"
      (valueChange)="setBadgeGranularity($event)"
    ></e-segmented-toggle>
  </hd-moments-calendar>
</ng-template>

<!-- Lijn-dag van de zon rechtsboven in een kalendercel (zelfde component als in de weekstrip). -->
<ng-template #sunLineCorner let-dayKey>
  @if (calendarSunLines().get(dayKey); as sunLine) {
    <hd-transit-sun-line [day]="sunLine" />
  }
</ng-template>
